import createReactComponent from '../createReactComponent';
export default createReactComponent('power', 'Power', [["path",{"d":"M17.953 5.25a9 9 0 1 1-11.906 0M12 3v9","key":"svg-0"}]]);